export const spanishMessages = {
	en: 'English',
	he: 'עברית',
	pt: 'Português',
	es: 'Espanhol',
	it: 'Italiano',
	PROFILE_IMAGE: 'Imagen del perfil',
	NAME: 'Nombre',
	PRICE: 'Precio',
	SEARCH: 'Buscar',
	IS_READ: 'Leído',
	DATE: 'Fecha',
	DASHBOARD_WELCOME: 'Bienvenida del panel de información',
	DASHBOARD: 'Panel de información',
	MONTHLY_REVENUE: 'Ingresos mensuales',
	NEW_ORDERS: 'Pedidos nuevos',
	MONTH_HISTORY: 'Usuario/as que se han unido en los últimos 30 días',
	VEHICLE_COLORS: 'Colores de vehículo',
	LEADS: 'Leads',
	FROM_DATE: 'Fecha inicial',
	TO_DATE: 'Fecha final',
	GENDER: 'Género',
	FULL_NAME: 'Nombre completo',
	HAS_CREDIT: '¿Tiene crédito?',
	BUDGET: 'Presupuesto',
	TOTAL: 'Total',
	VEHICLE_COLOR: 'Color del vehículo',
	FROM_CREATED_AT: 'Desde',
	TO_CREATED_AT: 'Hasta',
	TRAINEE: 'Deportista',
	TRAINEES: 'Deportistas',
	PORTUGEUSE: 'Portuguese',
	COACH: 'Entrenador/a',
	COACHES: 'Entrenadores/as',

	RECIPE_CATEGORY: 'Categoría de recetas',
	RECIPE_CATEGORIES: 'Categorías de recetas',

	RECIPE: 'Receta',
	RECIPES: 'Recetas',

	TAG: 'etiqueta',
	TAGS: 'etiquetas',

	PRODUCT: 'Producto',
	PRODUCTS: 'Productos',

	PRODUCT_CATEGORY: 'Categoría de productos',
	PRODUCT_CATEGORIES: 'Categorías de productos',

	MARATHON: 'Maratón',
	MARATHONS: 'Maratones',

	DYNAMIC_CARD: 'Tarjeta dinámica',
	DYNAMIC_CARDS: 'Tarjetas dinámicas',

	BILLBOARD: 'Cartelera',
	BILLBOARDS: 'Carteleras',

	TRAINING: 'Entrenamiento',
	TRAININGS: 'Entrenamientos',

	LIVE_TRAINING: 'Live Training',
	LIVE_TRAININGS: 'Live Trainings',

	LIVE_TRAININGS_MESSAGE: 'Live Training Message',
	LIVE_TRAININGS_MESSAGES: 'Live Trainings Messages',

	START_HOUR: 'Start Hour',
	END_HOUR: 'End Hour',

	TRAINING_CATEGORY: 'Categoría de entrenamientos',
	TRAINING_CATEGORIES: 'Categorías de entrenamientos',

	SUCCESS_STORY_CATEGORY: 'Categoría de historias de éxito',
	SUCCESS_STORY_CATEGORIES: 'Categorías de historias de éxito',
	SUCCESS_STORY: 'Historia de éxito',
	SUCCESS_STORIES: 'Historias de éxito',
	IMAGE: 'Imagen',
	DESCRIPTION: 'Descripción',
	ABOUT_ORGANIZATION: 'About Your Organization',
	Male: 'Hombre',
	Female: 'Mujer',
	FEATURED_IMAGE: 'Imagen destacada',
	TITLE: 'Título',
	CATEGORY: 'Categoría',
	CREATED_BY: 'Creada por',
	ORGANIZATION: 'Organización',
	GALLERY: 'Galería',
	DYNAMIC_CATEGORY_DEFAULT_IMAGE: 'Imagen predeterminada de categoría dinámica',
	LOGO_IMAGE: 'Logotipo',
	MARATHONS_FLAG: '¿Hay maratones disponibles?',
	COACH_FOLDER_FLAG: 'Coaches folder is publicly for all trainees?',
	COACH_REMINDER_EVERY: 'Recordar a los entrenadores/as cada...',
	COACH_REMINDER_EVERY_TYPE: 'Periodo',
	TRAINEE_REMINDER_EVERY: 'Recordar a los/las deportistas cada...',
	TRAINEE_REMINDER_EVERY_TYPE: 'Periodo',
	Admin: 'Administrador',
	Regular: 'Normal',
	EQUALS: 'Es igual',
	CONTAINS: 'Contiene',
	BETWEEN: 'Entre',
	Pending: 'Pendiente',
	Approved: 'Aprobado',
	SMS: 'SMS',
	Email: 'Correo electrónico',
	All: 'Todos',
	Toning: 'Tonificación',
	Mass: 'Masa',
	Coach: 'Entrenador/a',
	Trainee: 'Deportista',
	Organization: 'Organización',
	Vegetarian: 'Vegetariano/a',
	Hours: 'Horas',
	Days: 'Días',
	DAY: 'Día',
	Weeks: 'Semanas',
	Months: 'Meses',
	FEATURED_IMAGE_URL: 'URL de la imagen destacada',
	AGENDA: 'Agenda',
	DURATION: 'Duración',
	PHONE: 'Teléfono',
	MENU_PDF_URL: 'URL del PDF del menú',
	BIRTH_DATE: 'Fecha de nacimiento',
	EMAIL: 'Correo electrónico',
	HEIGHT: 'Estatura',
	WEIGHT: 'Peso',
	TRAINING_TYPE: 'Tipo de entrenamiento',
	APPROVED_BY_COACH: 'Aprobado por el/la entrenador/a',
	ADDRESS: 'Dirección',
	SHOULD_RECEIVE_MOTIVATION_NOTIFICATIONS: 'Debe recibir notificaciones de motivación',
	SHOULD_RECEIVE_WEIGHTING_REMINDER: 'Debe recibir recordatorios de pesaje',
	SHOULD_RECEIVE_SENDING_IMAGE_REMINDER: 'Debe recibir recordatorios de enviar imagen',
	SHOULD_COACH_RECEIVE_PERSONAL_MESSAGES_REMINDER: 'Debe el/la entrenador/a recibir recordatorios de mensajes personales',
	SHOULD_COACH_RECEIVE_TRAINEES_PROGRESS_REMINDER: 'Debe el/la entrenador/a recibir recordatorios de progreso de los/las deportistas',
	SHOULD_COACH_RECEIVE_BIRTHDAY_NOTIFICATIONS: 'Debe el/la entrenador/a recibir notificaciones de cumpleaños',
	SHOULD_COACH_RECEIVE_NON_UPLOADERS_REMINDER: 'Debe el/la entrenador/a recibir recordatorios de personas que no cargan',
	NOTE: 'Nota',
	VIDEO: 'Video',
	CARBS: 'Carbohidratos',
	PROTEINS: 'Proteínas',
	LINK: 'Enlace',
	NUMBER_OF_PARTICIPANTS: 'Cantidad de participantes',
	TOTAL_ACTIVE_MARATHONS: 'Total de maratones',
	TOTAL_ACTIVE_COACHES: 'Total de entrenadores/as',
	TOTAL_ACTIVE_TRAINEES: 'Total de deportistas',
	TOTAL_CLIENTS: 'Total de usuarias',
	ORGANIZATION_SETTINGS: 'Configuración de la organización',
	LANGUAGE: 'Idioma',
	HEBREW: 'Hebreo',
	SPANISH: 'Español',
	ENGLISH: 'Inglés',
	ITALIAN: 'Italiano',
	TOTAL_COACHES_CREATED: 'Deportistas convertidos/as en entrenadores/as',
	SAVED_SUCCESSFULLY: 'Archivo exitosamente',
	SENT_SUCCESSFULLY: 'Enviado correctamente',
	VERIFICATION: 'Verification code',
	VERIFICATION_CODE: 'Verification code',
	VERIFICATIONS: 'Verification codes',
	COACH_NEW_TRAINEE_ENLISTED_NOTIFICATION_TITLE: 'Titulo de notificación para el entrenador, sobre un cliente/alumno que se ha unido',
	COACH_NEW_TRAINEE_ENLISTED_NOTIFICATION_DESCRIPTION: 'Descripción de notificación para el entrenador, sobre un cliente/alumno que se ha unido',
	TRAINEE_APPROVED_NOTIFICATION_TITLE: 'Titulo de la notificación para el cliente/alumno sobre su permiso de entrada',
	TRAINEE_APPROVED_NOTIFICATION_DESCRIPTION: 'Descripción de notificación para el cliente/alumno sobre su permiso de entrada',
	COACH_NEW_MARATHON_ENLISTING_NOTIFICATION_TITLE: 'Titulo de la notificación sobre el cliente/alumno que se ha inscrito en el maratón',
	COACH_NEW_MARATHON_ENLISTING_NOTIFICATION_DESCRIPTION: 'Descripción de la notificación sobre el cliente/alumno que se ha inscrito en el maratón',
	TRAINEE_APPROVED_FOR_MARATHON_NOTIFICATION_TITLE: 'Título de la notificación para el cliente/alumno que ha sido aceptado en maratón',
	TRAINEE_APPROVED_FOR_MARATHON_NOTIFICATION_DESCRIPTION: 'Descripción  de la notificación para el cliente/alumno que ha sido aceptado en maraton',
	COACH_APPROVED_MARATHON_RESULTS_NOTIFICATION_TITLE: 'Coach approved marathon results title',
	COACH_APPROVED_MARATHON_RESULTS_NOTIFICATION_DESCRIPTION: 'Coach approved marathon results description',
	NEW_SUCCESS_STORY_TITLE: 'New success story title',
	NEW_SUCCESS_STORY_DESCRIPTION: 'New success story description',
	SUPPORTED_LANGUAGES: 'Idiomas soportados',
	DEFAULT_LANGUAGE: 'Idioma por defecto',
	general: {
		error: 'Error general'
	},
	message: {
		error: 'Error general'
	},
	error: {
		general: 'Error general',
		request: {
			invalid_req_params: 'Parámetros de la solicitud incorrectos'
		},
		files: {
			empty: 'Archivo vacío/No se envió un archivo',
			unsupported_ext: 'Extensión incompatible'
		},
		auth: {
			wrong_credentials: 'Credenciales incorrectas',
			not_admin: 'No es administrador',
			not_client: 'No es cliente/a',
			failed_authenticating_jwt: 'No se pudo autenticar',
			not_registered: 'Sin registrar',
			invalid_token: 'Token incorrecto '
		}
	},
	resources: {
		'verification': { name: 'Verification code' },
		'verifications': { name: 'Verification codes' },

		'trainee': { name: 'Trainee' },
		'trainees': { name: 'Trainees' },

		'coach': { name: 'Coach' },
		'coaches': { name: 'Coaches' },

		'recipe-category': { name: 'Recipe Category' },
		'recipe-categories': { name: 'Recipe Categories' },

		'recipe': { name: 'Recipe' },
		'recipes': { name: 'Recipes' },

		'product': { name: 'Product' },
		'products': { name: 'Products' },

		'product-category': { name: 'Product Category' },
		'product-categories': { name: 'Product Categories' },

		'marathon': { name: 'Marathon' },
		'marathons': { name: 'Marathons' },

		'dynamic-card': { name: 'Dynamic-card' },
		'dynamic-cards': { name: 'Dynamic-cards' },

		'billboard': { name: 'Billboard' },
		'billboards': { name: 'Billboards' },

		'training': { name: 'Training' },
		'trainings': { name: 'Trainings' },

		'training-category': { name: 'Training Category' },
		'training-categories': { name: 'Training Categories' },

		'success-story-category': { name: 'Success-story Category' },
		'success-story-categories': { name: 'Success-story Categories' },
		'success-story': { name: 'Success Story' },
		'success-stories': { name: 'Success Stories' },
		'vehicle-color': { name: 'Vehicle Color' },
		'lead': { name: 'Lead' }
	},
	ra: {
		action: {
			clear_input_value: 'Borrar',
			delete: 'Eliminar',
			unselect: 'Deseleccionar',
			sort: 'Ordenar',
			show: 'Mostrar',
			undo: 'Deshacer',
			confirm: 'Confirmar',
			bulk_actions: '%{smart_count} elementos seleccionados',
			list: 'Lista',
			export: 'Exportar',
			save: 'Guardar',
			create: 'Crear',
			edit: 'Editar',
			cancel: 'Cancelar',
			refresh: 'Actualizar',
			add_filter: 'Añadir filtro',
			remove_filter: 'Quitar filtro',
			back: 'Atrás'
		},
		boolean: {
			true: 'Sí',
			false: 'No'
		},
		page: {
			list: '%{name} Lista',
			edit: '%{name} n.º %{id}',
			show: '%{name} n.º %{id}',
			empty: 'No hay resultados',
			invite: 'Esperamos que pronto hayan datos',
			create: 'Crear %{name}',
			delete: 'Eliminar %{name} n.º %{id}',
			dashboard: 'Panel de información',
			not_found: 'No encontrado',
			error: 'Error'
		},
		input: {
			references: {
				single_missing: 'Faltante'
			},
			file: {
				upload_several:
					'Arrastra y suelta los archivos o haz clic para cargar.',
				upload_single: 'Arrastra y suelta los archivos o haz clic para cargar.'
			},
			image: {
				upload_several:
					'Arrastra y suelta los archivos o haz clic para cargar.',
				upload_single:
					'Arrastra y suelta los archivos o haz clic para cargar.'
			}
		},
		message: {
			error: 'Lo siento... Ocurrió un error',
			invalid_form: 'Formulario no válido',
			yes: 'Sí',
			no: 'No',
			are_you_sure: '¿Estás seguro/a?',
			about: 'Acerca de',
			not_found:
				'Insertaste un URL incorrecto o navegaste incorrectamente',
			delete_title: 'Eliminar',
			delete_content: '¿Estás seguro/a que deseas eliminar?',
			bulk_delete_title: '¡Nota!',
			bulk_delete_content: '¿Estás seguro/a que deseas eliminar TODAS las entidades?'
		},
		navigation: {
			no_results: 'No pudimos encontrar resultados',
			page_rows_per_page: 'Reglones por página',
			skip_nav: 'Omitir',
			page_out_of_boundaries: 'Página por fuera de los límites',
			page_out_from_end: 'Página por fuera del final',
			page_out_from_begin: 'Página por fuera del inicio',
			page_range_info: '%{offsetBegin}-%{offsetEnd} de un total de %{total}',
			next: 'Siguiente',
			prev: 'Anterior'
		},
		auth: {
			username: 'Nombre de usuario/a',
			password: 'Contraseña',
			sign_in: 'Iniciar sesión',
			sign_in_error: 'Error al iniciar sesión',
			logout: 'Cerrar sesión',
			auth_check_error: 'No se pudo autenticar'
		},
		notification: {
			data_provider_error: 'Error de conexión (proveedor de datos)',
			updated: 'La entidad se actualizó correctamente',
			created: 'La entidad se creó correctamente',
			deleted: 'La entidad se eliminó correctamente',
			item_doesnt_exist: 'El elemento no existe',
			http_error: 'Error de conexión (HTTP)'
		},
		validation: {
			required: 'Campo obligatorio',
			minLength: 'Debe contener mínimo %{min} caracteres',
			maxLength: 'Debe contener máximo %{max} caracteres',
			minValue: 'El valor debe ser mínimo %{min}',
			maxValue: 'El valor debe ser máximo %{max}',
			number: 'El valor debe un número',
			email: 'Correo electrónico incorrecto'
		}
	}
};
